import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { PlusIcon, SettingIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import { AAKeyword } from '../../../lib/types/models/aa-keywords/aa-keyword'

const AAKeywordListPage = () => {
  const tableRef = useRef<DynamicTableRef<AAKeyword>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<AAKeyword>[] = [
    {
      accessorKey: 'label',
      header: 'Label',
      enableSorting: true
    }
  ]

  return (
    <div>
      <UserNavBar title="AA" icon={SettingIcon} />
      <div className="h-4" />
      <DynamicDataTable<AAKeyword>
        ref={tableRef}
        title="AA"
        columns={columns}
        deleteMessage={{ name: 'label', attributeName: 'label' }}
        selectable
        allowSearchParam
        endpoint={API.aAKeyWords.getAll.url}
        onRowClick={(data, event) =>
          navigateWithEvent(Paths.AA_KEYWORD_UPDATE_PAGE.replace(':id', data.id.toString()), event)
        }
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            label: 'Créer AA',
            fn: () => navigate(Paths.AA_KEYWORD_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default AAKeywordListPage
